// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/payment-widget/payment-widget.less
// module id = 3366
// module chunks = 0